module.exports = __webpack_public_path__ + "img/制御工学5_1_5.c7abc8d9.png";